module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/appstore-2593582590d00e2e35258239b3e594a7.png";